import { createSelector } from 'reselect';


export function getLocationsLists(state) {
  return state.locationslist;
}

export function getLocationsListsById(state, currentLocationsListtId) {
  return getLocationsLists(state).get(currentLocationsListtId);
}


//=====================================
//  MEMOIZED SELECTORS
//-------------------------------------

export const getCurrentLocationsLists = createSelector(
  getLocationsLists,
  locationslist => locationslist.get(locationslist.get('currentLocationsListtId'))
);
